import React, { Component } from 'react';
import { submit } from 'redux-form';
import { connect } from 'react-redux';

import EditLeadBasicForm from './EditLeadBasicForm';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from 'material-ui/FlatButton';
import { putLead } from 'actions/landlordLeadsActions';

export default withMobileDialog()(
  connect(null, {
    submit,
    putLead,
  })(
    class EditLeadBasicDialog extends Component {
      UNSAFE_componentWillMount = () => {
        this.setState({
          disabledSubmit: false,
        });
      };

      submitForm = async formData => {
        this.setState({ disabledSubmit: true });
        await this.props.putLead(this.props.leadDetails.lead_id, formData);
        this.props.callback();
        this.setState({ disabledSubmit: false });
        this.props.toggleDialog();
      };

      render() {
        const { fullScreen } = this.props;

        return (
          <Dialog
            disableBackdropClick
            fullScreen={fullScreen}
            open={this.props.isOpen}
            onClose={this.props.toggleDialog}
            aria-labelledby="edit-lead"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="edit-lead-title">
              <h3 style={{ textAlign: 'center', margin: 0 }}>Edit Lead</h3>
            </DialogTitle>
            <DialogContent>
              <EditLeadBasicForm
                onSubmit={this.submitForm}
                initialValues={this.props.leadDetails}
              />
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.props.toggleDialog}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                CANCEL
              </FlatButton>
              <FlatButton
                variant="raised"
                onClick={() => this.props.submit('edit_lead_basic_form')}
                disabled={this.state.disabledSubmit}
                id="submit-button"
                style={{
                  color: 'white',
                  backgroundColor: this.state.disabledSubmit ? colors.LIGHT_GRAY : AccentColor(),
                }}
              >
                SAVE
              </FlatButton>
            </DialogActions>
          </Dialog>
        );
      }
    }
  )
);
